const env = {
    url: 'https://api.potabilis.innovareti.com.br/',
    api: 'https://api.potabilis.innovareti.com.br/api/v1/',
    applicationName: 'POTABILIS',
    applicationFooter: 'POTABILIS',
    chartBarBackgroundColor: '#2a4a80',
    isLocal: false
}

export default env

